import React from 'react';
import {
    Add,
    ArrowBackIos,
    ArrowForwardIos,
    BuildOutlined,
    CalendarTodayOutlined,
    ContactPageOutlined,
    Delete,
    Edit,
    EditOutlined,
    GroupsOutlined,
    FeedOutlined,
    FormatListBulletedOutlined,
    HelpOutlineSharp,
    HomeOutlined,
    LogoutOutlined,
    MenuOutlined,
    PersonOutlineOutlined,
    Search,
    SwapVert,
    SplitscreenOutlined,
    Visibility,
    VisibilityOutlined,
} from '@mui/icons-material';

import SouthOutlinedIcon from '@mui/icons-material/SouthOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CachedIcon from '@mui/icons-material/Cached';
import CodeIcon from '@mui/icons-material/Code';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import BarChartIcon from '@mui/icons-material/BarChart';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsBackupRestoreOutlinedIcon from '@mui/icons-material/SettingsBackupRestoreOutlined';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

import {CxStatusColor} from "./CxColor";


const ICON_MAP = {
    archive: Inventory2OutlinedIcon,
    avor: StraightenOutlinedIcon,
    avorReport: SummarizeOutlinedIcon,
    cache: CachedIcon,
    capa: BarChartIcon,
    category: SplitscreenOutlined,
    check: CheckCircleOutlinedIcon,
    cleaning: CleaningServicesOutlinedIcon,
    close: CloseOutlinedIcon,
    context: CodeIcon,
    contractor: ContactPageOutlined,
    create: Add,
    crew: PersonOutlineOutlined,
    delete: Delete,
    down: ArrowDownwardIcon,
    download: DownloadOutlinedIcon,
    error: ErrorOutlineOutlinedIcon,
    edit : EditOutlined,
    editAction : Edit,
    favorite: StarOutlinedIcon,
    help : HelpOutlineSharp,
    home : HomeOutlined,
    logout: LogoutOutlined,
    material: InventoryOutlinedIcon,
    menu: MenuOutlined,
    next: ArrowForwardIos,
    operation: RocketLaunchIcon,
    pending: PendingOutlinedIcon,
    print: PrintOutlinedIcon,
    project: FeedOutlined,
    plan: CalendarTodayOutlined,
    planExtend: Add,
    prev: ArrowBackIos,
    report: PostAddOutlinedIcon,
    restore: SettingsBackupRestoreOutlinedIcon,
    schema: SchemaOutlinedIcon,
    search: Search,
    searchProject: ManageSearchOutlinedIcon,
    searchTask: ContentPasteSearchOutlinedIcon,
    select: FileOpenOutlinedIcon,
    site: FactCheckOutlinedIcon,
    sort: SwapVert,
    abcSort: SouthOutlinedIcon,
    status: MonitorHeartOutlinedIcon,
    task: FormatListBulletedOutlined,
    team: GroupsOutlined,
    teamCapaOn: EngineeringIcon,
    teamCapaOff: EngineeringOutlinedIcon,
    typo: TextFieldsIcon,
    tool: BuildOutlined,
    up: ArrowUpwardIcon,
    upload: FileUploadIcon,
    view: VisibilityOutlined,
    viewAction: Visibility,
    warranty: VerifiedOutlinedIcon
};

export function CxIcon({ name, sx, ...props }) {
    const IconComponent = ICON_MAP[name] || ICON_MAP["help"];       // fallback to "help" if icon is not available
    return <IconComponent sx={sx} {...props} />;
};

export const CxStatusIcon = ({ status }) => {
     return <CxIcon name="status" sx={{ color: CxStatusColor[status] }} />;
};
